import { IconAlertCircle } from '@developerz/ui';
import { type JSX, Match, Switch } from 'solid-js';
import type { EnrollRefusal } from '../lib/enroll-refusal';
import { ConnectPlanLine } from './ConnectPlanLine';

// A refused enrollment's line, shared by both transports so the token mint and
// the SSH pull cannot word one refusal two ways. Presenter; which refusal is
// which is `lib/enroll-refusal.ts`'s rule.
//
//   - `seat_cap` reads as the plan line's own limit sentence, plain copy with
//     "See plans" (#6567): the plan is the limit, nothing failed.
//   - `org_unfunded` is the named refusal, which REPLACES the server's line
//     rather than stacking beside it: they say the same thing, and only ours
//     links billing.
//   - anything else is the server's own line, fatal unless the transport marked
//     it retryable.

export function EnrollRefusalAlert(props: { readonly refusal: EnrollRefusal }): JSX.Element {
  const seatCap = () => (props.refusal.kind === 'seat_cap' ? props.refusal : null);
  const line = () => (props.refusal.kind === 'line' ? props.refusal : null);
  return (
    <Switch fallback={<ConnectPlanLine plan={{ kind: 'org_unfunded' }} />}>
      <Match when={seatCap()}>
        {(cap) => <ConnectPlanLine plan={{ kind: 'at_limit', budget: cap().budget }} />}
      </Match>
      <Match when={line()}>
        {(l) => (
          <div
            class="alert alert--icon"
            classList={{ 'alert--destructive': !l().soft }}
            role="alert"
          >
            <IconAlertCircle />
            <p class="alert__title">{l().message}</p>
          </div>
        )}
      </Match>
    </Switch>
  );
}
